import React from 'react';
import _memoize from 'lodash.memoize';
import CommentsContext from '../../../contexts/commentsContext';
import CommentComponent from '../components/Comment';
import { AssetsSelector } from '../../../../Uploader';
import { AuthorisationConsumer } from '../../../../AuthorisationWrapper';


















const handleSelectComment = _memoize((comment, onSelectComment) => () => onSelectComment(comment)
);

function CommentContainer({
  comment,
  commentOrderByTimeline,
  commentIndex,
  getCommentTitle,
  isGroupSelected,
  onSelectComment,
  isCommentSelected,
  ...props
}) {
  return (
    <AuthorisationConsumer>
      {({ isShootstaUser }) =>
      <CommentsContext.Consumer>
          {({
          state: {
            canResolveComment,
            resourceOwnerUserId,
            pagesList,
            organisationName,
            allowedVisibilityOptions,
            resourceOrganisationId,
            allowedWriteVisibilityOptions
          },
          actions: {
            updateComment,
            getUserColor,
            deleteComment,
            editReply,
            deleteReply,
            createReply
          }
        }) =>
        <AssetsSelector assetIds={comment.assetIds || []}>
              {(assets) =>
          <CommentComponent
            allowedWriteVisibilityOptions={allowedWriteVisibilityOptions}
            commentIndex={commentIndex}
            comment={{ ...comment, assets }}
            commentOrderByTimeline={commentOrderByTimeline}
            canResolveComment={canResolveComment}
            getCommentTitle={getCommentTitle}
            getUserColor={getUserColor}
            isGroupSelected={isGroupSelected}
            isCommentSelected={isCommentSelected}
            onSelectComment={handleSelectComment(
              comment,
              onSelectComment
            )}
            updateComment={updateComment}
            deleteComment={deleteComment}
            editReply={editReply}
            deleteReply={deleteReply}
            createReply={createReply}
            resourceOwnerUserId={resourceOwnerUserId}
            showEditCommentModal={onSelectComment}
            pagesList={pagesList}
            organisationName={organisationName}
            allowedVisibilityOptions={allowedVisibilityOptions}
            isShootstaUser={isShootstaUser}
            resourceOrganisationId={resourceOrganisationId}
            {...props} />}


            </AssetsSelector>}

        </CommentsContext.Consumer>}

    </AuthorisationConsumer>);

}

export default CommentContainer;